export default __webpack_public_path__ + "static/1179-f9142e6eb89afe3df9ab276c3e869386.gif";